import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useTr } from "@/i18n";

export const faqs = [
  {
    q: "Quanto costa un DJ per un matrimonio in Ticino?",
    a: "Da CHF 150 a salire: feste private CHF 200-300, matrimoni da CHF 500 con impianto audio e luci incluso. Il prezzo finale dipende da durata, effetti speciali e trasferta. Ogni preventivo è gratuito, scritto e senza impegno: compila il modulo o scrivimi su WhatsApp.",
  },
  {
    q: "Venite anche a Zurigo, Ginevra o in altre città?",
    a: "Sì: ho base a Lugano-Paradiso ma lavoro in tutta la Svizzera con trasferte fino a circa 200 km, incluse Zurigo, Ginevra, Berna, Basilea e il Nord Italia (Como, Milano).",
  },
  {
    q: "L'attrezzatura audio e luci è inclusa?",
    a: "Sì, porto sempre il mio impianto audio e luci professionale, adatto a eventi fino a 1000 persone, con microfoni wireless per discorsi e cerimonie. Non dovete noleggiare nulla.",
  },
  {
    q: "Possiamo scegliere le canzoni?",
    a: "Assolutamente sì: la scaletta la costruiamo insieme prima dell'evento, con i vostri brani preferiti e la lista dei 'no' assoluti. Durante la festa leggo la pista e accolgo le richieste degli ospiti.",
  },
  {
    q: "Che generi musicali suoni?",
    a: "Il mio marchio di fabbrica: revival anni 80/90, disco dance, afro house e techno. Ma il repertorio spazia dagli anni '70 alle hit di oggi, per far ballare tutte le generazioni.",
  },
  {
    q: "Fai anche karaoke e animazione?",
    a: "Sì: karaoke professionale con migliaia di basi e, su richiesta, animazione con giochi musicali tra un set e l'altro. Perfetto per compleanni e feste di paese.",
  },
  {
    q: "Con quanto anticipo devo prenotare?",
    a: "Prima è, meglio è: i weekend tra maggio e settembre vanno via velocemente. Appena hai la data, contattami e la blocchiamo insieme.",
  },
  {
    q: "Parli altre lingue per eventi internazionali?",
    a: "Conduco ogni evento in italiano. Per matrimoni e feste con ospiti internazionali prepariamo insieme scaletta e annunci in anticipo, e il sito è consultabile anche in inglese e tedesco.",
  },
  {
    q: "Fate effetti speciali come le fontane fredde?",
    a: "Sì, su richiesta: fontane fredde per il primo ballo o il taglio della torta, effetti luce scenografici e laser show per un ingresso o un finale spettacolare.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  const tr = useTr();
  const items = tr("faq.items", faqs);

  return (
    <section id="faq" className="py-24 bg-[#080808]">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow={tr("faq.eyebrow", "Domande Frequenti")}
          title={tr("faq.title", "FAQ — Tutto quello che vuoi sapere")}
          accent={tr("faq.accent", "Le risposte alle domande che ricevo più spesso. Non trovi la tua? Scrivimi su WhatsApp.")}
          testid="faq-heading"
        />
        <div className="px-6 flex flex-col gap-3">
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={f.q}
                data-testid={`faq-item-${i}`}
                className={`gold-frame rounded-xl bg-[#111111] overflow-hidden ${
                  isOpen ? "border-[rgba(247,222,139,0.6)]" : ""
                }`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
              >
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-display text-base sm:text-lg font-semibold text-[#F7DE8B]">
                    {f.q}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 text-[#E2B857] transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  data-testid={`faq-answer-${i}`}
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-5 text-sm sm:text-base text-[#E2C882]/85 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
